import React from "react";

export default function CookieImage({ flavorKey = "brown_butter", imageUrl = "", className = "", style = {}, plateless = false }) {
  if (imageUrl) {
    return (
      <div
        className={`cookie-img cookie-img-custom ${plateless ? "plateless" : ""} ${className}`}
        style={{
          ...style,
          backgroundImage: `url("${imageUrl}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        data-testid={`cookie-image-${flavorKey}`}
        aria-hidden="true"
      />
    );
  }
  return (
    <div
      className={`cookie-img ${flavorKey} ${plateless ? "plateless" : ""} ${className}`}
      style={style}
      data-testid={`cookie-image-${flavorKey}`}
      aria-hidden="true"
    />
  );
}
